import React from "react";
import { styles } from "./LockedPost.styles";
import { POST_TYPE_IDS_ENUM } from "../../../../../constants/BrandedCommunity/Post";
import { UpgradeButton } from "./modules/UpgradeButton/UpgradeButton";
import { LockedImagePost } from "./modules/LockedImagePost/LockedImagePost";
import { ILockedPostProps } from "./LockedPost.interface";
import { LOCKED_POST_IMAGES } from "./constants/LockedPost.constants";

export * from "./LockedPost.interface";

export const LockedPost = ({
  data,
  handlePayment,
  paidPostCtaLabel,
}: ILockedPostProps) => {
  return (
    <>
      <div id={`post-text--${data.post_uuid}`} className={styles.postText}>
        {data.preview}
      </div>
      <img
        className={styles.lockedPostImg}
        src={LOCKED_POST_IMAGES.PREVIEW_DEFAULT}
        alt=""
      />
      {data.post_type === POST_TYPE_IDS_ENUM.DOCUMENT && (
        <img
          className={styles.lockedPostImg}
          src={LOCKED_POST_IMAGES.DOCUMENT_PLACEHOLDER}
          alt=""
        />
      )}
      {data.post_type === POST_TYPE_IDS_ENUM.POLL && (
        <img
          className={styles.lockedPostImg}
          src={LOCKED_POST_IMAGES.POLL_PLACEHOLDER}
          alt=""
        />
      )}
      {data.post_type === POST_TYPE_IDS_ENUM.IMAGE ||
      data.post_type === POST_TYPE_IDS_ENUM.VIDEO ||
      data.post_type === POST_TYPE_IDS_ENUM.AUDIO ? (
        <LockedImagePost onClick={handlePayment} ctaLabel={paidPostCtaLabel} />
      ) : (
        <UpgradeButton onClick={handlePayment} ctaLabel={paidPostCtaLabel} />
      )}
    </>
  );
};
